module.exports = __webpack_public_path__ + "img/profile-edit.cb9e88bf.svg";